/**
 * @typedef {object} TooltipState
 * @property {any} data
 * @property {any} requests
 *
 */
